@use '../../../styles/scrollbar' as scrollbar;

.content {
  max-height: 70vh;
  overflow-y: auto;
  @include scrollbar.themed;
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
